import createModel from "../createModel";

export const Message = createModel("Message", (json) => ({
    id: `${json.id}`,
    date: json.date,
    subject: json.subject,
    content: json.content,
    unread: json.statusCode === "UNREAD",
}));
